<div class="container">
  <div class="header">
    <div class="buttons flex space-between" *ngIf="vm.showActionButtons">
      <div class="flex row">
        <button>
          <span
            [ngStyle]="{
              'font-weight': vm.timeCodeType === 'FPS' ? 'bold' : '',
            }"
            >FPS</span
          >/<span
            [ngStyle]="{
              'font-weight': vm.timeCodeType === 'MS' ? 'bold' : '',
            }"
            (click)="vm.timeCodeTypeButtonClickedEventHandler()"
            >Milliseconds</span
          >
        </button>
      </div>
      <div class="flex row">
        <button
          class="flex column"
          (click)="vm.addNewSegmentClickedEventHandler()"
          title="Add a new segment and copy start time from the preview"
        >
          +
        </button>
        <remove-button
          class="flex column"
          [overrideClass]="'hover-black'"
          (click)="vm.deleteButtonClickedEventHandler()"
          title="Delete selected segments"
        ></remove-button>
      </div>
    </div>
  </div>
  <div class="body">
    <table>
      <thead>
        <tr>
          <th></th>
          <th>Segment ID</th>
          <th>Description</th>
          <th>TC IN</th>
          <th>TC OUT</th>
          <th>Duration</th>
          <th *ngIf="vm.showActionButtons">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let segmentVm of vm.segmentsVM">
          <td>
            <input
              type="checkbox"
              class="checkbox-field"
              (change)="vm.checkboxSelectedEventHandler(segmentVm)"
              [checked]="segmentVm.selected"
            />
          </td>
          <td>{{ segmentVm.tenantUniqueId }}</td>
          <td>
            <input
              type="text"
              class="description-field"
              [(ngModel)]="segmentVm.description"
              [readOnly]="!vm.fieldsEditable"
            />
          </td>
          <td>
            <div class="complex">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                (click)="vm.SeekPlayerToTime(segmentVm.timeInMs)"
              >
                <title>Go to IN</title>
                <path
                  _ngcontent-ng-c1802270569=""
                  d="M11.1421 12.5812C11.1421 13.0005 10.6571 13.2336 10.3297 12.9717L4.88013 8.61197C4.62993 8.4118 4.62993 8.03126 4.88013 7.8311L10.3297 3.47141C10.6571 3.20951 11.1421 3.44259 11.1421 3.86185V12.5812Z"
                  fill="white"
                ></path>
                <path
                  _ngcontent-ng-c1802270569=""
                  d="M3.80962 3.22778C3.31425 3.22778 2.89252 3.5063 2.89252 3.85556V12.5074C2.85905 13.3429 4.80036 13.3429 4.76689 12.5074V3.85556C4.80036 3.5063 4.33846 3.22778 3.80962 3.22778Z"
                  fill="white"
                ></path>
              </svg>
              <evrideo-time-editor
                [style]="vm.timeCodeFieldStyle"
                [(valueMs)]="segmentVm.timeInMs"
                [minMs]="0"
                [maxMs]="segmentVm.timeOutMs"
                [frameRate]="segmentVm.parentMedia.contentFps"
                [type]="vm.timeCodeType"
                [editMode]="vm.fieldsEditable"
              ></evrideo-time-editor>
            </div>
          </td>

          <td>
            <div class="complex">
              <evrideo-time-editor
                [style]="vm.timeCodeFieldStyle"
                [(valueMs)]="segmentVm.timeOutMs"
                [minMs]="segmentVm.timeInMs"
                [maxMs]="segmentVm.parentMedia.contentMediaDurationMs"
                [frameRate]="segmentVm.parentMedia.contentFps"
                [type]="vm.timeCodeType"
                [editMode]="vm.fieldsEditable"
              ></evrideo-time-editor>
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                (click)="vm.SeekPlayerToTime(segmentVm.timeOutMs)"
              >
                <title>Go to OUT</title>
                <path
                  _ngcontent-ng-c1802270569=""
                  d="M5.01904 12.5812C5.01904 13.0005 5.50401 13.2336 5.83139 12.9717L11.281 8.61197C11.5312 8.4118 11.5312 8.03126 11.281 7.8311L5.83139 3.47141C5.50401 3.20951 5.01904 3.44259 5.01904 3.86185V12.5812Z"
                  fill="white"
                ></path>
                <path
                  _ngcontent-ng-c1802270569=""
                  d="M12.3515 3.22778C12.8469 3.22778 13.2686 3.5063 13.2686 3.85556V12.5074C13.3021 13.3429 11.3608 13.3429 11.3942 12.5074V3.85556C11.3608 3.5063 11.8227 3.22778 12.3515 3.22778Z"
                  fill="white"
                ></path>
              </svg>
            </div>
          </td>
          <td>
            <evrideo-time-editor
              [style]="vm.timeCodeFieldStyle"
              [(valueMs)]="segmentVm.duration"
              [minMs]="0"
              [maxMs]="segmentVm.parentMedia.contentMediaDurationMs"
              [frameRate]="segmentVm.parentMedia.contentFps"
              [type]="vm.timeCodeType"
              [editMode]="vm.fieldsEditable"
            ></evrideo-time-editor>
          </td>
          <td *ngIf="vm.showActionButtons">
            <button
              (click)="vm.setStartTimeToSegment(segmentVm)"
              title="Set TC IN from the preview"
            >
              [
            </button>
            <button
              (click)="vm.setEndTimeToSegment(segmentVm)"
              title="Set TC OUT from the preview"
            >
              ]
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="footer flex justify-end">
    <ichannel-button
      *ngIf="vm.showCancelButton"
      [label]="'Cancel'"
      [callback]="vm.cancelButtonClickedEventHandler.bind(vm)"
      class="flex"
    ></ichannel-button>
    <ichannel-button
      *ngIf="vm.showApplyButton"
      [label]="'APPLY'"
      [theme]="'DARK'"
      [callback]="vm.applyButtonClickedEventHandler.bind(vm)"
      class="flex"
    ></ichannel-button>
  </div>
</div>
